import React from 'react'
import styles from "./style.module.scss"

interface props {
   text: string,
   checkAnswer: Function,
   disable: boolean,
   className?: string

}

const Answer: React.FC<props> = ({ text, checkAnswer, disable, className }) => {
   return (
      <button
         disabled={disable}
         onClick={() => checkAnswer(text)}
         className={`${styles.btn} ${styles[className || ""]}`}
      >
         <span dangerouslySetInnerHTML={{ __html: text }} />
      </button>
   )
}

export default Answer